import React from 'react';
import moment from 'moment';

import styles from './sugestao-venda.scss';

const SugestaoVenda = (props) => {

    const {venda} = props;
    

    return (
        <div
            >

            <span className={styles.idVenda}>
                #{venda.numeroVenda}
            </span>
            <span className={styles.nome}>
                {(venda.nome || "N/D")}
            </span>
            <span className={styles.total}>
                {venda.total}
            </span>
            <span className={styles.data}>
                {moment(venda.data).format("DD-MM-YYYY HH:mm:ss")}
            </span>
            
        </div>
    );
}

export {SugestaoVenda}